import { render, staticRenderFns } from "./ChunkFila.vue?vue&type=template&id=81121d38&"
import script from "./ChunkFila.vue?vue&type=script&lang=js&"
export * from "./ChunkFila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports